import Lead from "./Lead";
import DBObject from "../utils/DBObject";
import CloneContext from "../utils/CloneContext";

export default class LeadMailBoxRequest extends DBObject {
  private static readonly _LEAD: number = 0;
  private static readonly _OFFSET: number = 1;
  private static readonly _PAGESIZE: number = 2;
  private static readonly _SEARCHMAIL: number = 3;
  public id: number = 0;
  public otherMaster: DBObject;
  private _lead: Lead = null;
  private _searchMail: string = "";
  private _pageSize: number = 0;
  private _offset: number = 0;
  public constructor(
    d3eParams?: Partial<{
      lead: Lead;
      offset: number;
      pageSize: number;
      searchMail: string;
    }>
  ) {
    super();

    this.setLead(d3eParams?.lead ?? null);

    this.setOffset(d3eParams?.offset ?? 0);

    this.setPageSize(d3eParams?.pageSize ?? 0);

    this.setSearchMail(d3eParams?.searchMail ?? "");
  }
  public get d3eType(): string {
    return "LeadMailBoxRequest";
  }
  public clear(): void {
    this.d3eChanges.clear();
  }
  public get isTransientModel(): boolean {
    return;
  }
  public get lead(): Lead {
    return this._lead;
  }
  public setLead(val: Lead): void {
    let isValChanged: boolean = this._lead !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(LeadMailBoxRequest._LEAD, this._lead);

    this.updateObservable("lead", this._lead, val);

    this._lead = val;

    this.fire("lead", this);
  }
  public get searchMail(): string {
    return this._searchMail;
  }
  public setSearchMail(val: string): void {
    let isValChanged: boolean = this._searchMail !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(LeadMailBoxRequest._SEARCHMAIL, this._searchMail);

    this._searchMail = val;

    this.fire("searchMail", this);
  }
  public get pageSize(): number {
    return this._pageSize;
  }
  public setPageSize(val: number): void {
    let isValChanged: boolean = this._pageSize !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(LeadMailBoxRequest._PAGESIZE, this._pageSize);

    this._pageSize = val;

    this.fire("pageSize", this);
  }
  public get offset(): number {
    return this._offset;
  }
  public setOffset(val: number): void {
    let isValChanged: boolean = this._offset !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(LeadMailBoxRequest._OFFSET, this._offset);

    this._offset = val;

    this.fire("offset", this);
  }
  public get(field: number): any {
    switch (field) {
      case LeadMailBoxRequest._LEAD: {
        return this._lead;
      }

      case LeadMailBoxRequest._SEARCHMAIL: {
        return this._searchMail;
      }

      case LeadMailBoxRequest._PAGESIZE: {
        return this._pageSize;
      }

      case LeadMailBoxRequest._OFFSET: {
        return this._offset;
      }
      default: {
        return null;
      }
    }
  }
  public updateD3EChanges(index: number, value: any): void {
    if (this.lockedChanges()) {
      return;
    }

    super.updateD3EChanges(index, value);
  }
  public restore(): void {
    /*
TODO: Might be removed
*/

    this.d3eChanges.restore(this);
  }
  public deepClone(clearId = true): LeadMailBoxRequest {
    let ctx: CloneContext = new CloneContext({ "clearId": clearId });

    return ctx.startClone(this);
  }
  public collectChildValues(ctx: CloneContext): void {}
  public deepCloneIntoObj(dbObj: DBObject, ctx: CloneContext): void {
    let obj: LeadMailBoxRequest = dbObj as LeadMailBoxRequest;

    obj.id = this.id;

    obj.setLead(this._lead);

    obj.setSearchMail(this._searchMail);

    obj.setPageSize(this._pageSize);

    obj.setOffset(this._offset);
  }
  public set(field: number, value: any): void {
    switch (field) {
      case LeadMailBoxRequest._LEAD: {
        this.setLead(value as Lead);
        break;
      }

      case LeadMailBoxRequest._SEARCHMAIL: {
        this.setSearchMail(value as string);
        break;
      }

      case LeadMailBoxRequest._PAGESIZE: {
        this.setPageSize(value as number);
        break;
      }

      case LeadMailBoxRequest._OFFSET: {
        this.setOffset(value as number);
        break;
      }
    }
  }
}
